export const extractRoutineStatusTypeValue = (state: any) => {
  if (state?.state?.status === 'openEndedResponse') {
    return state?.state?.openEndedResponse;
  } else if (state?.state?.status) {
    return state?.state?.status;
  } else {
    return undefined;
  }
};